<template>
  <div
    class="groups-query-list card"
    :class="{ '-loading': loading }"
  >
    <loader v-if="loading"></loader>

    <div class="header">
      <div class="description">
        <h2 class="title">{{ title }}</h2>
        <p class="subtitle">{{ subtitle }}</p>
      </div>

      <card-actions>
        <button-dropdown color="primary">
          <template slot="button-content">Nova Consulta</template>

          <button-dropdown-item type="link" :to="{ name: 'Compliance-Physical-Person-Create' }">Pessoa Física</button-dropdown-item>
          <button-dropdown-item type="link" :to="{ name: 'Compliance-Legal-Person-Create' }">Pessoa Jurídica</button-dropdown-item>
          <button-dropdown-item type="link" :to="{ name: 'Compliance-Vehicles-Create' }">Veículos</button-dropdown-item>
          <button-dropdown-item type="link" :to="{ name: 'Compliance-Others-Create' }">Outros Documentos</button-dropdown-item>
        </button-dropdown>
      </card-actions>
    </div>

    <div
      class="body"
      :class="{ '-no-padding' : !errors.cantLoadList && !errors.cantLoadGroupQueriesList }"
    >
      <div class="alert -danger" v-if="errors.cantLoadList">
        <p class="title">Ops!</p>

        <p>
          Infelizmente aconteceu um erro ao tentar carregar suas consultas,
          por favor tente novamente ou contate nossa equipe.
        </p>
      </div>
      <div class="alert -danger" v-if="errors.cantLoadGroupQueriesList">
        <template slot="title">Ops!</template>

        <p>
          Infelizmente aconteceu um erro ao tentar exibir os detalhes,
          por favor tente novamente ou contate nossa equipe.
        </p>
      </div>

      <template v-if="!errors.cantLoadList">
        <table class="list">
          <thead>
          <tr class="-head">
            <th class="-rowaction"></th>
            <th>Identificador da pesquisa</th>
            <th>Data</th>
            <th>Valor (R$)</th>
            <th>Consultas</th>
            <th width="1%">Status</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="group in groups.data">
            <tr
              class="row"
              :class="{ '-expanded': groupExpanded === group.id }"
            >
              <td class="cell -expanseaction">
                <button class="expanse-group" @click="groupExpanded === group.id ? retractGroup(group) : expandGroup(group)">
                  <ion-icon :name="groupExpanded === group.id ? 'remove-circle-outline' : 'add-circle-outline'"></ion-icon>
                </button>
              </td>
              <td class="cell -queryinfo">{{ group.label }}</td>
              <td class="cell -queryinfo">{{ group.created_at | dateFormat('DD/MM/YY HH:mm') }}</td>
              <td class="cell -queryinfo">R$ {{ group.total | currency }}</td>
              <td class="cell -queryinfo">{{ group.ended }}/ {{ group.consultations }}</td>
              <td class="cell -queryinfo -statusinfo"><status-badge :status="group.consultations === group.ended ? 'done' : 'processing'"/></td>
            </tr>

            <!-- Batch - start -->
            <template v-if="groupExpanded === group.id && batchResumes.data.length > 0">
              <tr class="row -head -detail">
                <td class="cell -selectaction -downloadaction" width="1%">
                  <div
                    class="form-group"
                    style="display: flex;align-items: center;justify-content: center;"
                  >
                    <button
                      class="download-query -allqueries"
                      data-tooltip="Baixar todos os PDF's selecionados (apenas quando todos as consultas estão concluidas)"
                      :disabled="group.consultations !== group.ended"
                      @click="downloadZip(group.id)"
                    >
                      <ion-icon name="cloud-download"></ion-icon>
                    </button>
                  </div>
                </td>
                <td class="cell">Identificador</td>
                <td class="cell">Consulta</td>
                <td class="cell" colspan="3"></td>
              </tr>
              <tr class="row -detail -sub-group -expanded" v-for="requestQueue in batchResumes.data">
                <td class="cell -selectaction -downloadaction" width="1%"></td>
                <td class="cell -queryinfo">{{ requestQueue.label }}</td>
                <td class="cell -queryinfo">{{ requestQueue.endpoint }}</td>
                <td class="cell -queryinfo -statusinfo text-right" colspan="3"><status-badge status="error"/></td>
              </tr>
            </template>
            <template v-if="groupExpanded === group.id && batchResumes.data.length === 0">
              <tr class="row -detail -sub-group -expanded">
                <td class="cell -selectaction -downloadaction" width="1%">
                  <div
                    class="form-group"
                    style="display: flex;align-items: center;justify-content: center;"
                  >
                    <button
                      class="download-query -allqueries"
                      data-tooltip="Baixar todos os PDF's selecionados (apenas quando todos as consultas estão concluidas)"
                      :disabled="group.consultations !== group.ended"
                      @click="downloadZip(group.id)"
                    >
                      <ion-icon name="cloud-download"></ion-icon>
                    </button>
                  </div>
                </td>
                <td class="cell -queryinfo" colspan="6">Nenhuma consulta com erro.</td>
              </tr>
            </template>
            <!-- Batch - end -->

          </template>
          </tbody>
        </table>

        <div class="navList">
          <pagination
            :limit="1"
            :data="groups"
            @pagination-change-page="page = $event"
          >
            <span slot="prev-nav">Anterior</span>
            <span slot="next-nav">Próxima</span>
          </pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import currency from '@/support/filters/currency';
import dateFormat from '@/support/filters/dateFormat';
import queriesCompletedText from '@/compliance/filters/queriesCompletedText';
import apiLink from '@/support/filters/apiLink';
import CardActions from '@/support/components/card/CardActions.vue';
import Loader from '@/support/components/Loader.vue';
import StatusBadge from '@/compliance/components/StatusBadge.vue';
import ButtonDropdown from '@/support/components/buttons/ButtonDropdown.vue';
import ButtonDropdownItem from '@/support/components/buttons/button-dropdown/ButtonDropdownItem.vue';

export default {
  name: 'BatchQueryList',

  data() {
    return {
      loading: false,
      page: 1,
      groupExpanded: '',
      subGroupExpanded: [],
      queriesToDownload: [],
      canSelectAllQueriesToDownload: false,
      errors: {
        cantLoadList: false,
        cantLoadGroupQueriesList: false,
      },
    };
  },

  props: {
    title: {
      required: true,
      type: String,
    },
    subtitle: {
      required: false,
      type: String,
    },
    createRoute: {
      required: false,
    },
  },

  methods: {
    /**
     * Fetch the groups list.
     *
     * @returns {Promise<void>}
     */
    async fetchGroupsList() {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch(
          'compliance/fetchBatchList',
          { page: this.page },
        );
      } catch {
        this.errors.cantLoadList = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the all errors to initial value.
     */
    resetErrors() {
      this.errors.cantLoadList = false;
      this.errors.cantLoadGroupQueriesList = false;
    },

    /**
     * Expanse the compliance.
     *
     * @param id
     */
    async expandGroup({ id }) {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch(
          'compliance/fetchBatchQueriesList',
          { id },
        );

        this.groupExpanded = id;
        this.subGroupExpanded = [];
      } catch {
        this.errors.cantLoadGroupQueriesList = true;
      } finally {
        this.loading = false;
      }
    },

    expandSubGroup({ id }) {
      this.subGroupExpanded.push(id);
    },

    retractSubGroup({ id }) {
      const index = this.subGroupExpanded.findIndex((item) => item === id);

      if (index !== -1) {
        this.subGroupExpanded.splice(index, 1);
      }
    },

    /**
     * Retract the compliance.
     */
    retractGroup() {
      this.groupExpanded = '';
    },

    async downloadZip(id) {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch('compliance/requireBatchResultToEmail', id);

        this.$notify({
          group: 'app',
          type: 'success',
          title: 'Sucesso!',
          text: 'O resultado das consultas será enviado para seu e-mail em alguns minutos.',
        });
      } catch {
        this.errors.cantLoadGroupQueriesList = true;
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    ...mapState('compliance', {
      groups: 'groups',
    }),
    ...mapState('compliance', {
      batchResumes: 'batchResumes',
    }),
    ...mapState('auth', {
      accessToken: 'accessToken',
    }),
  },

  mounted() {
    this.fetchGroupsList();

    this.intervalFetchListAndGroup = setInterval(async () => {
      if (!this.loading) {
        await this.fetchGroupsList();

        if (this.groupExpanded) {
          await this.expandGroup({ id: this.groupExpanded });
        }
      }
    }, 1000 * 60);
  },

  beforeDestroy() {
    clearInterval(this.intervalFetchListAndGroup);
  },

  watch: {
    groupExpanded() {
      this.queriesToDownload = [];
    },

    page() {
      this.fetchGroupsList();
    },
  },

  filters: {
    currency,
    dateFormat,
    queriesCompletedText,
    apiLink,
  },

  components: {
    Pagination,
    CardActions,
    Loader,
    StatusBadge,
    ButtonDropdown,
    ButtonDropdownItem,
  },
};
</script>

<style lang="scss" scoped>
  .groups-query-list {
    > .body {
      > table.list {
        > thead,
        > tbody {
          > tr {
            > th,
            > td {
              .form-group {
                @apply mb-0;
              }

              &.-expanseaction {
                @apply text-center;
                @apply w-12;
                text-align: left;

                .expanse-group {
                  @apply relative;
                  @apply text-gray-500;
                  outline: none;
                  transform: scale(1.3);
                  top: 3px;
                }
              }

              &.-selectaction {
                width: 1rem;
                .form-group {
                  @apply mb-0;
                }
              }

              &.-downloadaction {
                @apply pr-2;
                .form-group {
                  @apply flex;

                  > .download-query {
                    @apply ml-2;
                    @apply text-sm;
                    @apply relative;
                    @apply text-gray-500;
                    outline: none;
                    transform: scale(1.3);

                    &:hover {
                      @apply text-gray-800;
                    }

                    &[disabled] {
                      @apply text-gray-300;
                      display: inline-block;
                      pointer-events: none;
                      text-decoration: none;
                      cursor: not-allowed;

                      &:hover {
                        @apply text-gray-300;
                      }
                    }

                    &.-allqueries {
                      top: 3px;
                    }
                  }
                }
              }

              &.-queryinfo {
                @apply text-sm;
                @apply text-secondary-900;
              }

              &.-statusinfo {
                white-space: nowrap;
                @apply pr-1;
              }
            }

            &.-head {
              @apply text-left;

              > .cell {
                @apply text-secondary-800;
                @apply text-xs;
                @apply font-bold;
              }
            }

            &.-detail,
            &.-expanded {
              @apply border-b-0;
              @apply border-t-0;
              background-color: rgba(58,104,255,0.1);
            }

            &.-detail {
              &:last-child {
                @apply border-b;
              }
            }

            &.-sub-group {
              .-expanseaction {
                width: 3.5rem;
                text-align: right;
              }
            }
          }
        }
      }

      > .navList {
        @apply flex;
        @apply justify-center;
      }
    }
  }
</style>
